import { BaseModel } from "./base/base.model";

export class AppAttendance extends BaseModel {
  attendanceRecord1?: string;
  type?: string;
  typeData?: {
    attendanceType1?: string;
    name?: string;
    company?: string;
    environment?: string;
    enabled?: boolean;
    entry?: boolean;
    createdAt?: string;
    modifiedOn?: string;
  };
  enabled?: boolean;
  environment?: string;
  company?: string;
  companyData?: {
    company1?: string;
    name?: string;
    companyCode?: Number;
    identifierNumber?: string;
  };
  source?: string;
  user?: string;
  userData?: {
    id?: string;
    name?: string;
    surname1?: string;
    surname2?: string;
    fullName?: string;
  };
  workCenter?: string;
  workCenterData?: {
    workCenter1?: string;
    workplaceCode?: string;
    name?: string;
    company?: string;
    environment?: string;
    enabled?: boolean;
    geolocation?: boolean;
    address?: string;
    coordinates?: string;
    createdAt?: string;
    modifiedOn?: string;
  };
  valid?: string;
  invalidReason?: string;
  coordinates?: string;
  geoMatch?: string;
  notes?: string;
  attendanceAt?: string;
  localAttendanceAt ?: string;
  timeZone ?: string;
  createdAt?: string;
  modifiedOn?: string;
  createdBy?: string;
  createdByData?: {
    id?: string;
    name?: string;
    surname1?: string;
    surname2?: string;
    fullName?: string;
  };
  modifiedBy?: string;
  modifiedByData?: {
    id?: string;
    name?: string;
    surname1?: string;
    surname2?: string;
    fullName?: string;
  };



  constructor(initValues?: Partial<AppAttendance>) {
    super();
    Object.assign(this, initValues);
  }
}

export class AppAttendanceSummary extends BaseModel {
  day?: string;
  localDay?: string;
  userData?: {
    id?: string;
    name?: string;
    surname1?: string;
    surname2?: string;
    fullName?: string;
  };
  firstEntryCenter?: string;
  firstEntryCenterData?: {
    workCenter1?: string;
    workplaceCode?: string;
    name?: string;
    company?: string;
    environment?: string;
    enabled?: boolean;
    geolocation?: boolean;
    address?: string;
    coordinates?: string;
    createdAt?: string;
    modifiedOn?: string;
  };
  firstType: string;
  firstTypeData: {
    attendanceType1: string,
    name: string,
    company: string,
    environment: string,
    enabled: boolean,
    entry: boolean,
    createdAt: string,
    modifiedOn: string
  };
  lastExitCenter?: string;
  lastExitCenterData?: {
    workCenter1?: string;
    workplaceCode?: string;
    name?: string;
    company?: string;
    environment?: string;
    enabled?: boolean;
    geolocation?: boolean;
    address?: string;
    coordinates?: string;
    createdAt?: string;
    modifiedOn?: string;
  };
  lastType: string;
  lastTypeData: {
    attendanceType1: string,
    name: string,
    company: string,
    environment: string,
    enabled: boolean,
    entry: boolean,
    createdAt: string,
    modifiedOn: string
  };
  valid?: string;
  totalHours?: string;
  invalidSummaryDayReasons?: string[];
  firstEntryTime?: string;
  firstEntryLocalTime?: string;
  firstEntryLocalTimeZone?: string;
  lastExitTime?: string;
  lastExitLocalTime?: string;
  lastExitLocalTimeZone?: string;
  records?: AppAttendance[];
  companyData?: { name?: string };


  constructor(initValues?: Partial<AppAttendanceSummary>) {
    super();
    Object.assign(this, initValues);
  }
}

